import script from "./PremiumFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./PremiumFeatures.vue?vue&type=script&setup=true&lang=js"

import "./PremiumFeatures.vue?vue&type=style&index=0&id=b8f46226&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8f46226"]])

export default __exports__